import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ConfigStore from "./store/ConfigStore";
import { ApolloProvider } from '@apollo/client';
import LoadingMaster from "./components/LoadingMaster/LoadingMaster";
import { client } from "./service/ApolloClient/ApolloClient";

import "./index.css";
import "react-toastify/dist/ReactToastify.css";

import App from "./containers/App/App";
import { BrowserRouter } from "react-router-dom";

// localStorage.clear()
let config = ConfigStore();

console.log("Environment:", process.env.NODE_ENV);
const app = (
  <Provider store={config.store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={config.persistor}>
        <ApolloProvider client={client}>
          <LoadingMaster />
          <App />
        </ApolloProvider>
      </PersistGate>
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA